import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8dedccfe3f2db3e/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FAQSection"] */ "/tmp/8dedccfe3f2db3e/components/sections/FAQSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SolutionsGrid"] */ "/tmp/8dedccfe3f2db3e/components/sections/SolutionsGrid.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/components/ui/Text.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/components/sections/KeyTakeawaysSection.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/app/[locale]/integrations/[slug]/integration.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8dedccfe3f2db3e/node_modules/next/dist/client/link.js");
